<template>
  <v-footer
    padless
    color="background"
    class="footer"
  >
    <v-row
      no-gutters
    >
      <v-col
        class="pl-1"
      >
        <v-btn
          icon
          variant="text"
          :href="$consts.TWITTER_URL"
          target="_blank"
          rel="noopener noreferrer"
          class="mx-1 my-1"
        >
          <font-awesome-icon
            :icon="['fab', 'x-twitter']"
            size="2x"
          />
        </v-btn>
      </v-col>
      <v-col
        class="text-right"
      >
        <locale-selector
          class="my-05"
        />
      </v-col>
    </v-row>
  </v-footer>
</template>

<script>
import LocaleSelector from '@/components/LocaleSelector.vue';

export default {
  name: 'Footer',
  components: {
    LocaleSelector,
  },
};
</script>

<style scoped>
.footer{
  z-index: 6;
}

.fa-2x {
  font-size: 1.7em;
}
</style>
